import React from 'react';
import { Link } from 'react-router-dom';
import './FeatureSpotlight.css';

const FeatureSpotlight = ({
  eyebrow,
  title,
  description,
  features = [],
  ctaLabel,
  ctaHref,
  secondaryLabel,
  secondaryHref,
  imageSrc,
  imageAlt = '',
  imagePosition = 'right',
  variant = 'white',
}) => {
  const gridClass =
    imagePosition === 'left'
      ? 'gn-feature-spotlight__grid--image-left'
      : 'gn-feature-spotlight__grid--image-right';

  const isExternal = (href) => /^https?:\/\//i.test(href);

  const renderCta = (label, href, className) => {
    if (!label || !href) return null;
    if (isExternal(href)) {
      return (
        <a className={className} href={href} target="_blank" rel="noopener noreferrer">
          {label}
        </a>
      );
    }
    return (
      <Link className={className} to={href}>
        {label}
      </Link>
    );
  };

  return (
    <section
      className={`gn-feature-spotlight gn-feature-spotlight--${variant}`}
      aria-labelledby={`spotlight-${title.replace(/\s+/g, '-').toLowerCase()}`}
    >
      <div className="gn-container">
        <div className={`gn-feature-spotlight__grid ${gridClass}`}>
          <div className="gn-feature-spotlight__copy">
            {eyebrow && <span className="gn-feature-spotlight__eyebrow">{eyebrow}</span>}
            <h2
              className="gn-title gn-feature-spotlight__title"
              id={`spotlight-${title.replace(/\s+/g, '-').toLowerCase()}`}
            >
              {title}
            </h2>
            {description && <p className="gn-feature-spotlight__desc">{description}</p>}
            {features.length > 0 && (
              <ul className="gn-feature-spotlight__features">
                {features.map((item) => (
                  <li key={item} className="gn-feature-spotlight__feature">
                    <span className="gn-feature-spotlight__feature-icon" aria-hidden="true">
                      ✓
                    </span>
                    {item}
                  </li>
                ))}
              </ul>
            )}
            <div className="gn-feature-spotlight__actions">
              {renderCta(ctaLabel, ctaHref, 'btn btn-gn-primary')}
              {renderCta(secondaryLabel, secondaryHref, 'gn-feature-spotlight__link')}
            </div>
          </div>
          {imageSrc && (
            <div className="gn-feature-spotlight__media">
              <div className="gn-feature-spotlight__media-frame">
                <img src={imageSrc} alt={imageAlt} loading="lazy" decoding="async" />
              </div>
            </div>
          )}
        </div>
      </div>
    </section>
  );
};

export default FeatureSpotlight;
